export const points = [
  {
    name: "5 Sats per sUSDe per day",
    logo: "/points/ethena.png",
    collateralVaults: ["0x8dDE384022D4dE1D6C67891a8865f551c444dc4C"],
  },
  {
    name: "20 Sats per USDe per day",
    logo: "/points/ethena.png",
    collateralVaults: ["0xAc73efA7696DC1c1617BbC20aeC64422c8b70EDa"],
  },
  {
    name: "2x Ether.fi points",
    logo: "/points/ethfi.png",
    collateralVaults: ["0xe846ca062aB869b66aE8DcD811973f628BA82eAf"],
  },
  {
    name: "2x Lombard Lux",
    logo: "/points/lombard.svg",
    collateralVaults: ["0x056f3a2E41d2778D3a0c0714439c53af2987718E"],
  },
  {
    name: "2x Lombard Lux",
    logo: "/points/lombard.svg",
    collateralVaults: ["0x998D761eC1BAdaCeb064624cc3A1d37A46C88bA4"],
  },
  {
    name: "3x Lombard Lux",
    logo: "/points/lombard.svg",
    collateralVaults: ["0xbC35161043EE2D74816d421EfD6a45fDa73B050A"],
  },
  {
    name: "Babylon Points",
    logo: "/points/babylon.png",
    collateralVaults: ["0xbC35161043EE2D74816d421EfD6a45fDa73B050A"],
  },
  {
    name: "2x Ether.fi points",
    logo: "/points/ethfi.png",
    collateralVaults: ["0xC605471aE09e0b7daA9e8813707d0DDbf9429Ad2"],
  },
  {
    name: "2x Lombard Lux",
    logo: "/points/lombard.svg",
    collateralVaults: ["0x82D2CE1f71cbe391c05E21132811e5172d51A6EE"],
  },
  {
    name: "2x Lombard Lux",
    logo: "/points/lombard.svg",
    collateralVaults: ["0x29A9E5A004002Ff9E960bb8BB536E076F53cbDF1"],
  },
  {
    name: "3x Lombard Lux",
    logo: "/points/lombard.svg",
    collateralVaults: ["0xA2038a5B7Ce1C195F0C52b77134c5369CCfe0148"],
  },
  {
    name: "Babylon Points",
    logo: "/points/babylon.png",
    collateralVaults: ["0xA2038a5B7Ce1C195F0C52b77134c5369CCfe0148"],
  },
  {
    name: "boosted rEUL if they are part of [turtle.club](https://turtle.club)",
    logo: "/points/turtle.png",
    isTurtleClub: true,
    skipValidation: true,
  },
  {
    name: "30x Resolv Points",
    logo: "/points/resolv.svg",
    collateralVaults: ["0xc60400289B32E840909795a063aeccFb093E0b47"],
  },
  {
    name: "20x Resolv Points",
    logo: "/points/resolv.svg",
    collateralVaults: ["0x3A8992754E2EF51D8F90620d2766278af5C59b90"],
  },
  {
    name: "5x Resolv Points",
    logo: "/points/resolv.svg",
    collateralVaults: [
      "0x9f12d29c7CC72bb3d237E2D042A6D890421f9899",
      "0xcBC9B61177444A793B85442D3a953B90f6170b7D",
    ],
  },
  {
    name: "20x Resolv Points",
    logo: "/points/resolv.svg",
    collateralVaults: ["0x7f1d29e70C644c387ded640B28E106e29E349074"],
  },
  {
    name: "5 Sats per sUSDe per day",
    logo: "/points/ethena.png",
    collateralVaults: ["0x498c014dE23f19700F51e85a384AB1B059F0672e"],
  },
  {
    name: "20 Sats per USDe per day",
    logo: "/points/ethena.png",
    collateralVaults: ["0x2daCa71Cb58285212Dc05D65Cfd4f59A82BC4cF6"],
  },
  {
    name: "5x Resolv Points",
    logo: "/points/resolv.svg",
    collateralVaults: ["0x3b028b4b6c567eF5f8Ca1144Da4FbaA0D973F228"],
  },
  {
    name: "2x Bera-Wave Points",
    logo: "/points/berastone.svg",
    collateralVaults: ["0xc4984bB39465465432321519839c489F4275B164"],
  },
  {
    name: "1x Ethereal points",
    logo: "/points/ethereal.svg",
    collateralVaults: ["0x61aAC438453d6e3513C0c8dbb69F13860E2B5028"],
  },
  {
    name: "3x Inception Totems",
    logo: "/points/inception.svg",
    collateralVaults: ["0x2306e17C7198282985a95b1cE0f63820846d0290"],
  },
  {
    name: "1x Mellow Points",
    logo: "/points/mellow.svg",
    collateralVaults: ["0x2306e17C7198282985a95b1cE0f63820846d0290"],
  },
  {
    name: "1x Symbiotic Points",
    logo: "/points/symbiotic.png",
    collateralVaults: ["0x2306e17C7198282985a95b1cE0f63820846d0290"],
  },
  {
    name: "10 Treehouse Nuts per ETH worth of tETH",
    logo: "/points/nuts.png",
    collateralVaults: ["0xA28C23a459fF8773EB4dBe0e7250d93F79F1Fe2B"],
  },
  {
    name: "5x OpenEden Bills",
    logo: "/points/openeden.png",
    collateralVaults: ["0x75f66ed34c274eaD52CFA25De9388E98e12Edb33"],
  },
  {
    name: "2x OpenEden Bills",
    logo: "/points/openeden.png",
    collateralVaults: ["0x738bC1e2F68F5ec58ea456fb4269B4b3f51714b5"],
  },
  {
    name: "140x for USN",
    logo: "/points/noon-points.svg",
    collateralVaults: ["0xc1fF5490651B9B8d0400B0146E7fb174B90E315B"],
  },
  {
    name: "20x for USDT",
    logo: "/points/noon-points.svg",
    collateralVaults: ["0xc7d526eFefa2e3073531f9e054F5c8cD1d0eC636"],
  },
  {
    name: "20x for USDC",
    logo: "/points/noon-points.svg",
    collateralVaults: ["0x53208e965EB66841598fB8f983a41936EeE6d774"],
  },
  {
    name: "10x for USN",
    logo: "/points/noon-points.svg",
    collateralVaults: ["0x89963076d2aBCf6b3C449A8f0f69439C47C0464d"],
  },
  {
    name: "1x Turtle Inception Points",
    logo: "/points/turtle-inception.png",
    collateralVaults: ["0x2306e17C7198282985a95b1cE0f63820846d0290"],
  },
  {
    name: "1x Ditto Points",
    logo: "/points/ditto.png",
    collateralVaults: ["0x2306e17C7198282985a95b1cE0f63820846d0290"],
  },
  {
    name: "1x mev-commit points",
    logo: "/points/mev-commit.png",
    collateralVaults: ["0x2306e17C7198282985a95b1cE0f63820846d0290"],
  },
  {
    name: "1x Human Network points",
    logo: "/points/human-network.jpg",
    collateralVaults: ["0x2306e17C7198282985a95b1cE0f63820846d0290"],
  },
  {
    name: "1 reservoir point per rUSD per day",
    logo: "/points/reservoir.svg",
    collateralVaults: ["0x6DFC8ae855FA8Ab7bAbB81aB7c8a6DA7794f60fB"],
  },
  {
    name: "0.5 reservoir point per srUSD per day",
    logo: "/points/reservoir.svg",
    collateralVaults: ["0x16d84F98765Ed86501a052D47E76BFefb2D36206"],
  },
  {
    name: "1x Kalypso Points",
    logo: "/points/kalypso.png",
    collateralVaults: ["0x2306e17C7198282985a95b1cE0f63820846d0290"],
  },
  {
    name: "1x Radius Points",
    logo: "/points/radius.png",
    collateralVaults: ["0x2306e17C7198282985a95b1cE0f63820846d0290"],
  },
  {
    name: "5x Yala Berries",
    logo: "/points/berry.png",
    collateralVaults: ["0x481D4909D7ca2eb27c4975f08dCE07DBeF0d3Fa7"],
  },
  {
    name: "3x Yala Berries",
    logo: "/points/berry.png",
    collateralVaults: ["0x1F46186AF85A967416b17380800c69860B7C516F"],
  },
  {
    name: "2.5x Upshift Points",
    logo: "/points/upshift.png",
    collateralVaults: ["0x87c414825aB3d1E9bdC773e9B1fD968822c9CF51"],
  },
  {
    name: "5x Upshift Points",
    logo: "/points/upshift.png",
    collateralVaults: ["0x3F714090F7648139043349f599A48904187d76D0"],
  },
  {
    name: "2x Kernel Points",
    logo: "/points/kernel.png",
    collateralVaults: ["0x3F714090F7648139043349f599A48904187d76D0"],
  },
  {
    name: "30x Falcon Miles",
    logo: "/points/falcon.png",
    collateralVaults: [
      "0x3573A84Bee11D49A1CbCe2b291538dE7a7dD81c6",
      "0x412D0E31790D77b6e7a7872a9fd6967B6E640229",
    ],
  },
  {
    name: "2x Falcon Miles",
    logo: "/points/falcon.png",
    collateralVaults: ["0x2F849ba554C1ea2eDe9C240Bbe9d247dd6eC8A6B"],
  },
  {
    name: "1x YieldFi Points",
    logo: "/points/yieldfi.png",
    collateralVaults: ["0x3eD8f77Ca6FD9e5c6DBBcC9696BF93F30C3A2BA5"],
  },
  {
    name: "2.5x YieldFi Points",
    logo: "/points/yieldfi.png",
    collateralVaults: ["0xc727069c0eb261Be642272fe3848518192683fFc"],
  },
  {
    name: "3x Wave Points",
    logo: "/points/hyperwave.svg",
    collateralVaults: ["0x22cC732cbca457F6811295bCE75B01822544bA52"],
  },
  {
    name: "3x Wave Points",
    logo: "/points/hyperwave.svg",
    liabilityVaults: ["0x22cC732cbca457F6811295bCE75B01822544bA52"],
  },
  {
    name: "5x Pareto Efficiency Points",
    logo: "/points/pareto.png",
    collateralVaults: ["0xa94F9CE821C7bD57cc12991CB46ca19f5789278F"],
  },
  {
    name: "3x Wave Points",
    logo: "/points/hyperwave.svg",
    collateralVaults: ["0x3C75C170671acb394804DfAf63e4F9891C121625"],
  },
  {
    name: "3x Wave Points",
    logo: "/points/hyperwave.svg",
    liabilityVaults: ["0x3C75C170671acb394804DfAf63e4F9891C121625"],
  },
  {
    name: "30x Strata Points",
    logo: "/points/strata.svg",
    collateralVaults: [
      "0x6331D36C27D967c4261D59a8f80d58d03089810A",
      "0xF0ee6229CB0c3ed8DA93cA49191c7261566783AF",
    ],
  },
  {
    name: "30x Ethena Points",
    logo: "/points/ethena.png",
    collateralVaults: [
      "0x6331D36C27D967c4261D59a8f80d58d03089810A",
      "0xF0ee6229CB0c3ed8DA93cA49191c7261566783AF",
    ],
  },
  {
    name: "Caps",
    logo: "/points/caps_w_square.svg",
    collateralVaults: [
      "0x6Fe7Fa90756434645F0b0428fDff78E99Dda0FBc",
      "0x35d4f830543700B7280084280ae3236f178E88e3",
    ],
  },
  {
    name: "20x Strata Points",
    logo: "/points/strata.svg",
    collateralVaults: ["0x53AfE3343f322c4189Ab69E0D048efd154259419"],
  },
  {
    name: "Bedrock Diamonds",
    logo: "/points/bedrock.png",
    collateralVaults: ["0xf4Be316983b70B5fF8dc8C0DDd62156EF2DCa454"],
  },
  {
    name: "30x Gems",
    logo: "/points/asf.svg",
    collateralVaults: [
      "0x477d7feE2d9dca0bA8F7CbEAa7da219b5bb2d1a7",
      "0x51147D1af05AEb441dE62db292f46580084c8380",
      "0x46DEA62E4D631ce3FaC68ECeC2b1C4bA1500075A",
    ],
  },
  {
    name: "10x Strata Points",
    logo: "/points/strata.svg",
    collateralVaults: ["0xfa68974D007D755697Cc4D4E1e4057034EA666df"],
  },
  {
    name: "5x Ethena Points",
    logo: "/points/ethena.png",
    collateralVaults: ["0xfa68974D007D755697Cc4D4E1e4057034EA666df"],
  },
] as const
